import { Loader_sidebar } from './loader_sidebar';
import { Autocomplete, TextField, Chip } from '@mui/material';
import {ReactComponent as Segmentation_people} from './Layer_images/Settings_images/segmentation_people.svg'
import {ReactComponent as Segmentation_calendar} from './Layer_images/Settings_images/segmentation_calendar.svg'
import {ReactComponent as Segmentation_dollar} from './Layer_images/Settings_images/segmentation_dollar.svg'
import populationSegmentation from './json/population_segments.json';
import React, {  useState, useEffect } from 'react';

const age_mappings = {
  'under_18': 'Youth',
  '18_24': 'Young Adults',
  '25_34': 'Establishing Adults',
  '35_44': 'Mid-Career Adults',
  '45_54': 'Established Adults',
  '55_64': 'Pre-Retiree',
  '65_plus': 'Retired'
}

const age_segments = {
  'under_18': 'Under 18',
  '18_24': '18 - 24',
  '25_34': '25 - 34',
  '35_44': '35 - 44',
  '45_54': '45 - 54',
  '55_64': '55 - 64',
  '65_plus': '65+'
}

const income_segments = {
  'low_income': '$0-30,000',
  'lower_middle_income': '$30,000-50,000',
  'middle_income': '$50,000-75,000',
  'upper_middle_income': '$75,000-125,000',
  'high_income': '$125,000-200,000',
  'very_high_income': '$200,000+'
}

const income_mapping = {
  low_income: 'Essential Income',
  lower_middle_income: 'Building Income',
  middle_income: 'Stable Income',
  upper_middle_income: 'Comfortable Income',
  high_income: 'Affluent Income',
  very_high_income: 'Elite Income',
}

const region_mapping = {
  'Urban Core': 'Metro',
  Urban: 'City',
  Suburban: 'Suburbs',
  Rural: 'Rural'
}

const age_options = [
  {label: 'Under 18', value: 'under_18'},
  {label: '18-24', value: '18_24'},
  {label: '25-34', value: '25_34'},
  {label: '35-44', value: '35_44'},
  {label: '45-54', value: '45_54'},
  {label: '55-64', value: '55_64'},
  {label: '65+', value: '65_plus'},
];

const income_options = [
  {label: '$0-30k', value: 'low_income'},
  {label: '$30k-50k', value: 'lower_middle_income'},
  {label: '$50k-75k', value: 'middle_income'},
  {label: '$75k-125k', value: 'upper_middle_income'},
  {label: '$125k-200k', value: 'high_income'},
  {label: '$200k+', value: 'very_high_income'},
];

const region_options = [
  {label: 'Metro', value: 'Urban Core'},
  {label: 'City', value: 'Urban'},
  {label: 'Suburbs', value: 'Suburban'},
  {label: 'Rural', value: 'Rural'},
];

export const Segmentation = ({ 
  segmentation, 
  loading, 
  exportInd, 
  selectedAges, 
  selectedIncome, 
  selectedRegion, 
  onAgeChange, 
  onIncomeChange, 
  onRegionChange,
  segmentationClicked,
  premiumFeatureClicked,
  demo
}) => {

  const [segmentData, setSegmentData] = useState([]);
  
  useEffect(() => {
    var segment = segmentation ? segmentation : [];
    segment = exportInd ? segment.slice(0, 5) : segment;
    setSegmentData(segment);
  }, [segmentation]);

  const get_image_link = (age, income) => {
    var income_value = 1;
    if(age != 'under_18'){

     const income_mapping = { 'low_income': 1, 'lower_middle_income': 2, 'middle_income': 3, 'upper_middle_income': 4, 'high_income':5,  'very_high_income': 6}
     income_value = income_mapping[income]
    }
    
    return `segmentation/${age}_${income_value}.jpeg`
  }

  const getDescription = (age_group, income_group, region_type) => {
    if (age_group === 'under_18') {
      income_group = 'low_income'
    }
    
    // console.log(`${age_group}_${income_group}_${region_type}`)
    let description = populationSegmentation[`${age_group}_${income_group}_${region_type}`].description;
    
    // Check if description is longer than 100 characters
    if (description.length > 200) {
      // Find the last space within the first 100 characters
      const lastSpaceIndex = description.substring(0, 200).lastIndexOf(' ');
      
      // Truncate at the last space and add "..."
      description = description.substring(0, lastSpaceIndex) + "...";
    }
    
    return description;
  }

  function formatNumber(value) {
    // Check if the value is a number
    if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
      // Convert to number to handle string numbers, then to string for formatting
      return Number(value).toLocaleString();
    } else {
      // Return the original value if it's not a number
      return value;
    }
  }

  return (
    <div className="sidebar-realestate-total" id="export-values-psycho">
      {exportInd ? <h2 className='mb-20 mt-100 font-weight600 data-component' >Segmentation</h2>: <div className="react-class-filter">
        <Autocomplete
          multiple
          options={age_options}
          getOptionLabel={(option) => option?.label || ""}
          value={selectedAges || []}
          onChange={(event, newValues) => onAgeChange(newValues)}
          renderTags={(values, getTagProps) =>
            values.map((option, index) => (
              <Chip
                variant="outlined"
                label={option?.label || option}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Age"
              placeholder={selectedAges?.length ? "" : "Select age ranges"}
              sx={{
                "& .MuiInputLabel-root": { fontSize: '12px' },
                "& input": { fontSize: '12px' },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                    borderWidth: '1px',
                  },
                  "&:hover fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.87)',
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: 'primary.main',
                  }
                }
              }}
            />
          )}
        />
        <Autocomplete
          multiple
          options={income_options}
          getOptionLabel={(option) => option?.label || ""}
          value={selectedIncome || []}
          onChange={(event, newValues) => onIncomeChange(newValues)}
          renderTags={(values, getTagProps) =>
            values.map((option, index) => (
              <Chip
                variant="outlined"
                label={option?.label || option}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Income"
              placeholder={selectedIncome?.length ? "" : "Select income ranges"}
              sx={{
                "& .MuiInputLabel-root": { fontSize: '12px' },
                "& input": { fontSize: '12px' },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                    borderWidth: '1px',
                  },
                  "&:hover fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.87)',
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: 'primary.main',
                  }
                }
              }}
            />
          )}
        />
        <Autocomplete
          multiple
          options={region_options}
          getOptionLabel={(option) => option?.label || ""}
          value={selectedRegion || []}
          onChange={(event, newValues) => onRegionChange(newValues)}
          renderTags={(values, getTagProps) =>
            values.map((option, index) => (
              <Chip
                variant="outlined"
                label={option?.label || option}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Region"
              placeholder={selectedRegion?.length ? "" : "Select regions"}
              sx={{
                "& .MuiInputLabel-root": { fontSize: '12px' },
                "& input": { fontSize: '12px' },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                    borderWidth: '1px',
                  },
                  "&:hover fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.87)',
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: 'primary.main',
                  }
                }
              }}
            />
          )}
        />
      </div>}
      {exportInd && <p className='mb-20 font-weight600 data-component color-black' >This section highlights the top 5 visitor segments for this location, providing a snapshot of the most frequent visitors and helping you better understand the primary audience.</p>}
      {loading ? 
        (segmentData.length > 0 ? 
          segmentData.map((e) => (
            <div key={e.age_group + e.income_group + e.region_type} className='data-component'>
              
              <div className='box-container mtb-10 p-10'>
                <div className='display-flex gap-10 sidbar-primary-text'>
                  {e.age_group && <div className='display-flex gap-10'><div >{age_mappings[e.age_group]}</div><div>•</div></div>}
                  {e.income_group && <div className='display-flex gap-10'><div>{income_mapping[e.income_group]}</div><div>•</div></div>}
                  {e.region_type && <div className='display-flex gap-10'><div>{region_mapping[e.region_type]}</div></div>}
                  {!exportInd &&<div className='ml-auto display-flex gap-10 cursor-pointer' style={{color: '#1570EF'}} onClick={() => demo ? premiumFeatureClicked('market_segmentation') : segmentationClicked(e) }><div>See more</div><div className='display-flex font-size-20' style={{padding: '1px 2px 0px 5px'}}><div className='rotate-90 mr-6 position-absolute mt-2' style={{    fontSize: '15px', fontWeight: 700}}>|</div> <div className='fa fa-angle-right position-absolute ' style={{    marginLeft: '-4px'}}></div></div></div>}
                </div>
                <div className='display-flex gap-10  mtb-10 sidbar-primary-text'>
                  <img   src={get_image_link(e.age_group, e.income_group)}  className='segmentation-profile-image'/>
                  <div className="box-container">
                    <div className='segmentation-top-sidebar'>
                      <div className='display-inline-block pt-5'><Segmentation_people/></div>
                      <div className='display-inline-block font-size-10'>Number of People</div>
                    </div>
                    <div className='text-align-left pl-5' style={{color: '#1570EF'}}>{formatNumber(e.total_pop)}</div>
                  </div>
                  <div className="box-container">
                    <div className='segmentation-top-sidebar'>
                      <div className='display-inline-block pt-5'><Segmentation_calendar/></div>
                      <div className='display-inline-block font-size-10'>Age Group</div>
                    </div>
                    <div className='text-align-left pl-5' >{age_segments[e.age_group]}</div>
                  </div>
                  <div className="box-container">
                    <div className='segmentation-top-sidebar'>
                      <div className='display-inline-block pt-5'><Segmentation_dollar/></div>
                      <div className='display-inline-block font-size-10'>Income Group</div>
                    </div>
                    <div className='text-align-left pl-5' >{income_segments[e.income_group]}</div>
                  </div>
                </div>
                <div className='segmentation-text-sidebar'>{getDescription(e.age_group, e.income_group, e.region_type)}</div>
              </div>
            </div>
          ))
        : <div>No results match your filter criteria</div>)
      : <div>{demo ?  <div className="total-locations-sidebar">
            <div className="name-locations-sidebar add-location-warning">
            For demo purposes, segments are only visible for selected locations. Please click on a location on the map to view its market segments.
            </div>
        </div>: <Loader_sidebar />}</div>
      }
    </div>
  );
};